<template>
  <div ref="container" class="frc-captcha" :style="{ width: '100%' }"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {FRCWidgetCompleteEvent, FriendlyCaptchaSDK, WidgetHandle} from "@friendlycaptcha/sdk";
import i18n from "@/i18n";
import EnvironmentService from "@/services/EnvironmentService";

export default defineComponent({
  data() {
    return {
      widget: undefined as WidgetHandle | undefined,
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'test') {
      return;
    }
    const sdk = new FriendlyCaptchaSDK();
    const siteKey = EnvironmentService.applicationConfiguration.friendlyCaptchaSiteKey;
    const container = this.$refs.container as HTMLElement;
    this.widget = sdk.createWidget({
      element: container,
      sitekey: siteKey,
      language: i18n.global.locale === 'cz'? 'cs': i18n.global.locale,
      startMode: "auto",
      apiEndpoint: "eu",
    });
    this.widget.addEventListener("frc:widget.complete", (e: FRCWidgetCompleteEvent) => {
      this.$emit("complete", e.detail.response);
    });
    this.widget.addEventListener("frc:widget.error", () => {
      this.$emit("complete", "");
    });
    this.widget.addEventListener("frc:widget.expire", () => {
      this.$emit("complete", "");
    });
  },
  unmounted() {
    if (this.widget) {
      this.widget.destroy();
      this.widget = undefined;
    }
  }
});
</script>
<style lang="scss" scoped>
</style>
